import React from "react";
import { Link } from "react-router-dom";
import FrontendLayout from "../../components/frontend/FrontendLayout";

const Disclaimer: React.FC = () => {
  return (
    <FrontendLayout>
      <section
        className="flat-title style-2 mb-4 tf-spacing-1 inner-banner inner-banner"
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner mb-0 pt-0 d-flex justify-content-between">
                <ul className="breadcrumb">
                  <li>
                    <Link to="/" className="home fw-6 text-color-3">
                      Home
                    </Link>
                  </li>
                  <li>Disclaimer</li>
                </ul>
                <h5 className="mt-3">Disclaimer</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-disclaimer style-2 tf-spacing-1 pb-0">
        <div className="tf-container tf-spacing-1 pt-0">
          <div className="row">
            <div className="col-lg-12">
              <div className="content-inner">
                <div className="heading-section mb-27">
                  <h2 className="title split-text effect-right">
                    Disclaimer
                  </h2>
                </div>
                <div
                  className="content mb-48 wow animate__fadeInUp animate__animated"
                  data-wow-duration="1s"
                  data-wow-delay="0s"
                >
                  <p className="text-1 description-1 mb-16">
                    The information provided on this website is for general informational purposes only. My LandMart makes no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.
                  </p>
                  <p className="text-1 description-1 mb-16">
                    In no event will My LandMart be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.
                  </p>
                  <p className="text-1 description-1 mb-16">
                    Through this website, you may be able to link to other websites which are not under the control of My LandMart. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
                  </p>
                  <p className="text-1 description-1 mb-16">
                    Every effort is made to keep the website up and running smoothly. However, My LandMart takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.
                  </p>
                  <p className="text-1 description-1 mb-16">
                    The information on this website does not constitute financial, legal, or professional advice. You should consult with a qualified professional for advice tailored to your specific circumstances before making any decisions.
                  </p>
                </div>
                <div className="contact-section text-center">
                  <p className="text-1 mb-24">
                    For any questions or concerns regarding this disclaimer, please{" "}
                    <Link to="/contact-us">contact us</Link>.
                  </p>
                  <Link
                    to="/contact-us"
                    className="tf-btn bg-color-primary pd-3 fw-6 mx-auto"
                  >
                    Get in Touch
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </FrontendLayout>
  );
};

export default Disclaimer;